module.exports = __webpack_public_path__ + "static/media/RenatoSchiratti.cf7a5312.jpg";